import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import anim_line from "../../img/winter.png"
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";

import LoadingButton from "../../Loading/LoadingButton";
import { useSelector } from "react-redux";
import {Activity, HopIcon, Plus } from 'lucide-react';
import Snackbar from "../../../Snackbar";
import { createCourseByAdminV2 } from "../../../store/actions/CreateCourse/createCourseByAdmin";
import AppMenuCardBlue from "../AppCards/AppMenuCardBlue";
import { getProductByProductId } from "../../../api";
import AreYouSurePopUp from "../../Create/CreateContent/ContentPopUp/AreYouSurePopUp";
import WhatsIncludedAddMore from "../../Create/CreateCourse/WhatsIncludedAddMore";
import AppMenuCardBlueBG from "../AppCards/AppMenuCardBlueBG";
import NextStepCardPopUp from "../AppCards/NextStepCardPopUp";
import AddDemoVideosAddMoreSubCourse from "../../Create/CreateContent/SubCourse/AddDemoVideosAddMoreSubCourse";
const AddDemoVideosProducts = ({setActiveCardOverview,baseUrl})=>{
  const {courseId} = useParams();
  const {url}=useRouteMatch();
  const history = useHistory();
   const dispatch = useDispatch();

   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
  const [goNextPopUp, setGoNextPopUp] =useState(false);
 
 const showSnackbar = () => {
   setSnackbarVisible(true);
 };

 const hideSnackbar = () => {
   setSnackbarVisible(false);
 };
 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
  {
    
    dispatch({type: "CURSOR",payload:true  });

    dispatch({type: "CURSORTEXT",payload:CursorText})
    dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
    dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
  }
   
  const handleMouseLeave = () => {
    
    dispatch({type: "CURSOR",payload:false})

    dispatch({type: "CURSORTEXT",payload:""})

    dispatch({type: "CURSORTEXTBG",payload:""})
    dispatch({type: "CURSORTEXTCOLOR",payload:""})
  

}
  
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
 const user_email = useSelector((state)=>state?.user?.user?.user_email
);

const postIdCourse = useSelector((state)=>state?.course?.course?.postId);

const courseData = useSelector((state)=>state?.course?.course);
const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const appId = useSelector((state)=>state?.app?.app?.ID);
const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);

 const [loader , setLoader] =useState({status:false});
 const [productID, setProductID] = useState(courseData?.ID?courseData?.ID:"");
 const [editType, setEditType] = useState(courseData?.ID?"videoLinks":"");
const videoLinks =courseData?.videoLinks?JSON.parse(courseData?.videoLinks):[];
 const [itemArr, setItemArr] = useState(videoLinks?.length?videoLinks:[]);
 
  const [selectedItemIndex, setSelectedItemIndex] = useState(null); // Track hovered drop zone
  
 const [animate, setAnimate] = useState(false);
function generateTimestamp() {
    return Math.floor(Date.now() / 1000);
  }
 
 useEffect(() => {
  
 }, []);

  const updateItemLink = (id, newLink) => {
    const updatedItems = itemArr.map(item =>
      item?.id === id ? { ...item, youtubeLink :newLink } : item
    
    ); 
    setItemArr(updatedItems);
  };





useEffect(()=>{
  // setCourseTitleData();
// console.log(itemArr)
videoLinks?.length !== 0?setItemArr(videoLinks):
  setItemArr([
    { no:1, id: generateTimestamp(), status:false,contentIcon:`Video`
        ,youtubeLink:"https://www.youtube.com/watch?v=Bn-3ICGjz0U" ,
        youtubeLinkTitle:"The Weeknd - Open Hearts (Official Video)",editable:true},   
         { no:2, id: generateTimestamp()+1, status:false,contentIcon:`Video`
            ,youtubeLink:"https://www.youtube.com/watch?v=RB-RcX5DS5A" ,
            youtubeLinkTitle:"Coldplay - The Scientist (Official 4K Video)",editable:true},
   
    
    // { no:2, id: generateTimestamp()+1, status:false,contentIcon:`Video`
    //     ,youtubeLink:"" ,editable:true},
]);
},[])



 useEffect(() => {
    // console.log(itemArr)
   // Trigger the animation after a delay (e.g., 500ms)
   const timer = setTimeout(() => {
    setAnimate(true);  
  }, 100);

   return () => clearTimeout(timer); // Cleanup on unmount
 }, []);
useEffect(()=>{
  setActiveCardOverview(true);
  
  // setCourseTitleData();
},[])



  const handleCreateProduct=()=>{
  
  
  
  setLoader({status:true});
  
    const apiData = dispatch(createCourseByAdminV2({videoLinks:JSON.stringify(itemArr),type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editType,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){
        if(response?.course){
          
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
    setItemArr(JSON.parse(response?.course?.videoLinks));
    setProductID(response?.course?.postId);
   setEditType("videoLinks")
   setGoNextPopUp(true);
  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }
    
    function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }
     
     useEffect(() => {
       // Trigger the animation after a delay (e.g., 500ms)
       const timer = setTimeout(() => {
        setAnimate(true);  
      }, 100);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, []);
    
     const removeItem = (id) => {
        const filteredItems = itemArr.filter(item => item.id !== id);
        setItemArr(filteredItems);
      };
      const updateItemTotalNumber = (id, newTotalNumber) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, totalNumber: newTotalNumber } : item
        
        ); 
        setItemArr(updatedItems);
      };const updateItemTitle = (id, newTitle) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item,  youtubeLinkTitle :newTitle } : item
        
        ); 
        // console.log(updatedItems)
        setItemArr(updatedItems);
      };
      const updateItemStatus = (id, status) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, status: status } : item
        
        );
    
    
    
        setItemArr(updatedItems);
    
        
        setTimeout(()=>{
          // console.log(updatedItems)
              },1000)
      };
    const flattenedData = itemArr.length?Object.values(itemArr):[];
    
    
    
    
    
      const [position, setPosition] = useState({ x: 0, y: 0 });
      
      const [draggedIndex, setDraggedIndex] = useState('');
      const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone
    
      const handleDragStart = (e, index) => {
        
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData("dragIndex", index);
        
      };
    
      const handleDrop = (e, dropIndex) => {
        const dragIndex = e.dataTransfer.getData("dragIndex");
        if (dragIndex === dropIndex) return;
    
        const updatedItems = [...itemArr];
        const [draggedItem] = updatedItems.splice(dragIndex, 1);
        updatedItems.splice(dropIndex, 0, draggedItem);
    
        const reorderedItems = updatedItems.map((item, index) => ({
          ...item,
          id: item?.id,
        }));
        setItemArr(reorderedItems);
        setDraggedIndex('');
        setHoveredDropZone(null); // Reset hovered drop zone
      };
    
      const handleDragOver = (e, index) => {
        e.preventDefault();
         // Set the hovered drop zone
      };
    
      const handleDragEnd = () => {
        setDraggedIndex('');
        setHoveredDropZone(null); // Clear hovered drop zone
      };
    
    
const handleBack=(e)=>{
  
    setLoader({status:true});
    
    history.goBack();
    }
    
    return <>
    
{<>
  {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}

<div  className="ikcraft_login-signup-card-outerj"style={{}}><div  className="CreateCourseStepsOuter contentPageScroller" style={{background:"#fff",borderRadius:"25px"}}>
<div > 
<div  className=""style={{
        transform: animate ? 'scale(1)' : 'scale(.9)',marginTop:"20px",
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 1s ease',
      }}>
         
<div align="left" className="itemCourseOuter" style={{marginTop:"0px",marginBottom:"0px",height:"280px",background:"rgba(86, 82, 131,.8)"}}> 
                
                <div  className="whatToDoNextItemCardInner" ><div style={{background:"#fff",width:"50px",height:"50px",borderRadius:"50%",
                      float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><HopIcon size={32}  color="rgb(86, 82, 131)"/></div> 
              
                
                </div> 
<div   class="CreateCourseStepsOuterTitle" style={{color:"#fff",padding:"5px"}}> Add Your  One Or More Youtube Lecture Videos  </div>
<div  class="CreateCourseStepsOuterSubTitle" style={{color:"#fff",padding:"5px"}}>Students Love To See Their Teachers Style And In-Depth Knowledge. </div>

              <div  style={{display:"flex",justifyContent:"center"}}>
              <AppMenuCardBlue activeCard={""} icon={1} title ="Skip To Next Phase " onClickPopup={
          ()=>{  history.push(`${baseUrl}/labels`)
          }}  />
           </div>   </div>
       </div>
    </div>  <div  className="CreateCourseStepsOuterRight " >
   
     
     <div className="" style={{position:"relative"}} >
           
           {flattenedData?flattenedData.map((item, index) => 
                   (<div  index={index} key={item?.id}  
                     ><div
                     className="drop-zone"
                     onDragOver={(e) => {setHoveredDropZone(index);
                       handleDragOver(e, index)
                     }}
                     onDrop={(e) => handleDrop(e, index)}
                   
                     style={{
                       height: hoveredDropZone === index ?'200px':"0px",position:hoveredDropZone === index ?'relative':"",left:"0px",right:"0px",
                       backgroundColor: hoveredDropZone === index ? 'rgba(149, 143, 218,0.2) ' : 'transparent', // Change color on hover
                       border: hoveredDropZone === index ? '2px dashed rgba(149, 143, 218,1) ' : 'transparent', // Change color on hover
                       transition: 'background-color  0.3s ease',width:"95%",
                       borderRadius: '10px',marginBottom:hoveredDropZone === index ?"10px":"0px"
                      
                     }}
                   ></div>
                       <div
                       
                        draggable 
                        
           onDragOver={(e) => { if(selectedItemIndex!==index){setHoveredDropZone(index);
               handleDragOver(e, index)}
             }}
             onDrop={(e) => {if(selectedItemIndex!==index){handleDrop(e, index);setSelectedItemIndex(null);}}}
           
                        onDragStart={(e) =>{ handleDragStart(e, index);
                         setDraggedIndex(item?.id);setSelectedItemIndex(index);
                        }}style={{
                            transform: animate ? 'translateY(0)' : 'translateY(50px)',
                           
                           transition: `transform ${1+index}s ease`,zIndex:"999"
                         ,
                         cursor: 'move',width:"100%",
                         // backgroundColor: hoveredDropZone === index+1 ? "#f1f1f1":
                         // hoveredDropZone === index ?"#f1f1f1":"",
                         // transform: hoveredDropZone === index+1 ? "scale(0.90)":
                         // hoveredDropZone === index ?"scale(0.90)":"",
                         // // marginTop: hoveredDropZone === index+1 ? "-10px":
                         // hoveredDropZone === index ?"10px":"",
                        
                         
                       }}  className={draggedIndex == item?.id?"posFixed":"posRelative"  }
                     
                         onDragEnd={handleDragEnd}
                       ><AddDemoVideosAddMoreSubCourse index={index} key={item?.id} 
                    changeItemStatus ={updateItemStatus } 
                     youtubeLink={item?.youtubeLink} youtubeLinkTitle={item?.youtubeLinkTitle} no={item?.no} id={item?.id} totalNumber={item?.totalNumber} status={item?.status} 
                     contentIcon={item?.contentIcon}  editable={item?.editable}  changeItemTitle={updateItemTitle } changeItemLink={updateItemLink } onRemove={removeItem} />
                     </div>
                     
                     </div>)):'' }
               
               <div align="center">
           <div align="center"  style={{width:"100%",
                }}> 
                 <div onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave} className="coloredTextV1" style={{marginTop:"15px",padding:"10px",}}>Add New Youtube Link</div>
                 
                 
             <div onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave} onClick={()=>setItemArr([...itemArr, {no: itemArr.length, id: generateTimestamp()+2
                 , totalNumber: 0,status:true,contentIcon:`Video`,
                 youtubeLink:"" ,youtubeLinkTitle:"",editable:true}])}style={{width:"40px",height:"40px",cursor:"pointer",
                   borderRadius:"50%",margin:"5px",marginBottom:"20px",
                 background:"#958FDA"}} > <Plus  style={{margin:"9px"}}  color="#ffffff" size={22}/></div>
                 </div>
               </div>
               </div> 
 
   <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  
    
    <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{handleBack()}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
     id="signupBtn"> Back </button>

 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateProduct()}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
     id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":productID?"Update":"Save"} </button>
     
  </div>
  
    <div  className="ikcraft_login-input-card">
   
      
  </div>

  <div> 
    
    
    
    
  </div>
 </div>
    
 <div></div>
 {goNextPopUp?<NextStepCardPopUp loadingText="Going Next Phase..."  title="Let's Go To Next Phase  .   Let's Go!" type="addAproxContent"
 closePopUp={()=>{setGoNextPopUp(false)}}
 onClickPopup={(type)=>{setTimeout(()=>{
  history.push(`${baseUrl}/labels`)
 },1000)
  }}/>:""}

  </div></div>
</>}
    </>

}

export default AddDemoVideosProducts;



